
/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function(Flits) {
  /* To load js in all pages */
  if(Flits.Metafields.IS_SOCIAL_LOGIN_PAID && Flits.Metafields.IS_SOCIAL_LOGIN_ENABLE){
    if(window.flitsObjects.allCssJs.socialLoginJs){
        Flits.LoadStyleScript('socialLoginJs',window.flitsObjects.allCssJs.socialLoginJs.url);
    }
  }
  Flits(document).on('Flits:Navigation:Loaded', function(event){
    var settings = event.detail.settings;
    var obj = {
      title: 'Rewards & Loyalty',
      url:'#smile-home',
      target:0,
      badge: null,
      icon: null,
      isShow: 1,
      loader:null,
      body_html:null
    }
    settings.navs.splice(5, 0, obj);
	});
  Flits(document).on('Flits:AddressDefault:Click', function(event){
    var form = event.detail.item;
    var countryVal = form.find(".flits-address-phone-with-country-div .flits-country-code-textbox").val();
    if(!countryVal){
      Flits('.flits-address-card-action').removeClass('flits-disabled');
      flitsSnackbar.show({ text: "Please add your phone country code", pos: "bottom-center", showAction: !1, customClass: "flits-alert-danger", duration: 2400 });
    }
  });
  Flits(document).on('Flits:AddressSave:Click', function(event){
    var form = event.detail.item;
    var countryVal = form.find(".flits-address-phone-with-country-div .flits-country-code-textbox").val();
    if(!countryVal){
      flitsSnackbar.show({ text: "Please add your phone country code", pos: "bottom-center", showAction: !1, customClass: "flits-alert-danger", duration: 2400 });
    }
  });
}(Flits));
